import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";

import { FileUploadArea, UploadedFileCard } from "components/common";
import { FormLabel } from "components/ui";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { actions, selectors } from "store/caseCreate";

import { createFileForStore } from "utils/fileHelpers";
import {
  Box,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Colors } from "consts/colors";
import useGetScannerList from "hooks/useGetScannerList";

export const OtherFiles = () => {
  const otherFiles = useAppSelector(selectors.getOtherFilesSelector);
  const order = useAppSelector(selectors.getAllInfoSelector);
  const dispatch = useAppDispatch();
  const filesUploadHandler = (files: File[]) => {
    dispatch(actions.setOtherFiles(files.map(createFileForStore)));
  };
  const filesDeleteHandler = (name: string) => {
    dispatch(actions.deleteOtherFile(name));
  };

  const handleSendScansViaMeditLink = (value: boolean) => {
    dispatch(actions.setSendScansViaMeditLink(value));
  };

  const { scannerlist, selectedScanner, setSelectedScanner } =
    useGetScannerList(true);

  const uploadFiles = (params: {
    fileId: string;
    controller: AbortController;
    contentType: string;
  }) => {
    dispatch(
      actions.downloadFile({
        ...params,
        fileType: "otherFiles",
      })
    );
  };
  return (
    <Grid container mt={3}>
      <Grid item md={6}>
        <Stack spacing={2}>
          <Typography variant="body2" color={Colors.SECONDARY} lineHeight={2}>
            You can send through a scanner portal or upload STL file directly.
          </Typography>
          <Box pl={1.2} pb={1}>
            <FormControlLabel
              style={{ columnGap: "0.5rem" }}
              checked={order.useMeditLink}
              onChange={(_, value) => handleSendScansViaMeditLink(value)}
              control={<Checkbox style={{ padding: 0 }} />}
              label={
                <Typography
                  variant="body2"
                  color={Colors.SECONDARY}
                  lineHeight={2}
                >
                  Sending through Scanner Portal
                </Typography>
              } //!link to the help article how use portal
            />
          </Box>
          {order.useMeditLink && (
            <Select
              labelId="scannerType"
              id="scannerTypeSelect"
              defaultValue={selectedScanner}
              size="small"
              inputProps={{ "aria-label": "Without label" }}
              onChange={(e) => {
                if (e.target.value) setSelectedScanner(e.target.value);
              }}
              sx={{
                width: `${(selectedScanner?.length ?? 10) + 5}ch`,
              }}
            >
              {scannerlist.map((brand) => (
                <MenuItem key={brand} value={brand}>
                  {brand}
                </MenuItem>
              ))}
            </Select>
          )}
          {!order.useMeditLink && (
            <Typography
              variant="body2"
              color={Colors.SECONDARY}
              lineHeight={2}
              align="center"
            >
              or
            </Typography>
          )}
        </Stack>
        {!order.useMeditLink && (
          <FormLabel
            label="Upload your scans (STL format)"
            required={!order.preEval}
          >
            <FileUploadArea
              error={order.requiredFields.includes("otherFiles")}
              onFilesUpload={filesUploadHandler}
            />
            <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
              {otherFiles.map((file) => (
                <UploadedFileCard
                  key={file.id}
                  file={file}
                  onUpload={uploadFiles}
                  onDelete={filesDeleteHandler}
                />
              ))}
            </Stack>
          </FormLabel>
        )}
      </Grid>
    </Grid>
  );
};
